// removed by extract-text-webpack-plugin
module.exports = {"content":"styles__content___2CesB","popup":"styles__popup___2U9eg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/styles.scss
// module id = 157
// module chunks = 0